module.exports = __webpack_public_path__ + "img/yej.e85c38aa.png";